module.exports = __webpack_public_path__ + "img/mapLeft.3c4fa0fd.svg";